module.exports = __webpack_public_path__ + "img/praised.d3bf488a.png";